import React, { createContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollContext = createContext({
  scrolled: false,
  setScrolled: () => {}
});

// ScrollToTop component to reset scroll position on page navigation
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

export const ScrollProvider = ({ children }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <ScrollContext.Provider value={{ scrolled, setScrolled }}>
      {children}
    </ScrollContext.Provider>
  );
}; 